import { TokenInfoResult } from '@/types';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { useAtomValue } from 'jotai';
import { tokenInfoAtom } from '@/atoms/tokenInfo';

export const Breakdown = () => {
  const tokenInfo = useAtomValue(tokenInfoAtom);
  return (
    <Card className="h-full">
      <CardHeader>
        <CardTitle>Breakdown</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-400">MINT:</span>
          <a
            href={tokenInfo?.mint_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:underline"
          >
            View
          </a>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">MC:</span>
          <span className="text-white uppercase">${tokenInfo?.mc_str}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">AGE:</span>
          <span className="text-white">{tokenInfo?.age}</span>
        </div>
      </CardContent>
    </Card>
  );
};

export const OldBreakdown = ({ tokenInfo }: { tokenInfo?: TokenInfoResult }) => {
  return (
    <div className="bg-[#1A1F2E] rounded-lg p-6 h-[220px]">
      <h2 className="text-sm font-medium text-white mb-4 uppercase">Breakdown</h2>
      <div className="space-y-3">
        <div className="flex justify-between items-center">
          <span className="text-gray-400">MINT:</span>
          <a
            href={tokenInfo?.mint_url}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-400 hover:underline"
          >
            View
          </a>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">MC:</span>
          <span className="text-white">{tokenInfo?.mc_str}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-white">{tokenInfo?.liq_str}</span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">AGE:</span>
          <span className="text-white">{tokenInfo?.age}</span>
        </div>
      </div>
    </div>
  );
};
